<template>
  <v-list-item
    
    
    :active-class="``"
    @click="selectpage()"
  >
  <!--
    :input-value='conpareJSON(datapage, item.to)'
    :color="conpareJSON(datapage, item.to)? 'orange':'primary'"
  -->
    <v-list-item-icon v-if="item.icon || item.image" class="background">
      <v-icon v-if="item.icon" v-text="item.icon"/>
      <v-img 
        v-if="item.image" 
        :src='conpareJSONPage(datapage, item.to)? require("@/assets/images/icon/" + item.image + "-active.png"):require("@/assets/images/icon/" + item.image + ".png")'
        
      ></v-img>
    </v-list-item-icon>
    

    <v-list-item-content v-if="item.title">
      <v-list-item-title :class="conpareJSONPage(datapage, item.to)? 'orange--text':''" v-text="item.title" />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  import Themeable from 'vuetify/lib/mixins/themeable'
  import { mapState, mapMutations } from "vuex";
  export default {
    name: 'BaseItem',

    mixins: [Themeable],

    props: {
      item: {
        type: Object,
        default: () => ({
          href: undefined,
          image: undefined,
          icon: undefined,
          title: undefined,
          to: undefined,
        }),
      },
      text: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      ...mapState(["datapage"]),
      href () {
        return this.item.href || (!this.item.to ? '#' : undefined)
      },
    },

    methods:{
      ...mapMutations({
        setPage: "SET_DATAPAGE",
      }),
      selectpage(){
        let pagedata = {
          ...this.item.to,
          //to: this.item.to
        };
        this.setPage(pagedata)
      },
      conpareJSON(obj1, obj2) {
        let listkey1 = Object.keys(obj1);
        let listkey2 = Object.keys(obj2);
        if (listkey1.length != listkey2.length) {
          return false;
        }else {
          for(let i in listkey1) {
            if(obj1[listkey1[i]] != obj2[listkey1[i]]) {
              return false;
            }
          }
          return true;
        }
      },
      conpareJSONPage(obj1, obj2) {
        return obj1.Page == obj2.Page;
      }
    },
  }
</script>
<style>

</style>